$(function () {
  $('.promo-product-cards').each(function () {
    var mql = window.matchMedia("(max-width: 1023px)")

    mediaqueryresponse(mql)

    mql.addListener(mediaqueryresponse)

    function mediaqueryresponse(mql) {
      var $featuredCard = $('.product-featured .pro-card-wrapper .pro-card:first-child .pro-card-clip');

      var $unfeaturedCardTwo = $('.product-unfeatured-2 .pro-card-wrapper .pro-card:first-child .pro-card-clip');

      var $unfeaturedCardThree = $('.product-unfeatured-3 .pro-card-wrapper .pro-card:nth-child(2) .pro-card-clip');

      var $unfeaturedCardFour = $('.product-unfeatured-4 .pro-card-wrapper .pro-card:nth-child(2) .pro-card-clip');

      var $unfeaturedCardFive = $('.product-unfeatured-5 .pro-card-wrapper .pro-card:nth-child(3) .pro-card-clip');

      var $unfeaturedCardSix = $('.product-unfeatured-6 .pro-card-wrapper .pro-card:nth-child(3) .pro-card-clip');

      if (mql.matches) {
        $('.product-featured .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($featuredCard).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.product-unfeatured-2 .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($unfeaturedCardTwo).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.product-unfeatured-3 .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($unfeaturedCardThree).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.product-unfeatured-4 .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($unfeaturedCardFour).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.product-unfeatured-5 .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($unfeaturedCardFive).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.product-unfeatured-6 .pro-card-headers').find('h4:nth-child(2)').detach().insertAfter($unfeaturedCardSix).css({
          'margin-top': '40px',
          'margin-bottom': '-16px',
          'text-align': 'center'
        });

        $('.primary-two-up').each(function () {
          promoHeight = $(this).find('.pro-card-wrapper').find('.pro-card').find('.pro-card-content').outerHeight();
          $(this).find('.pro-card-wrapper').find('.pro-card-img').css('height', promoHeight)
        });
        $('.primary-three-up').each(function () {
            promoHeight = $(this).find('.pro-card-wrapper').find('.pro-card').find('.pro-card-content').outerHeight();
          $(this).find('.pro-card-wrapper').find('.pro-card-img').css('height', promoHeight)
        });

      } else {
        var $featuredHeader = $('.product-featured .pro-card-headers').children('h4:first-child');
        var $unfeaturedHeaderTwo = $('.product-unfeatured-2 .pro-card-headers').children('h4:first-child');
        var $unfeaturedHeaderThree = $('.product-unfeatured-3 .pro-card-headers').children('h4:first-child');
        var $unfeaturedHeaderFour = $('.product-unfeatured-4 .pro-card-headers').children('h4:first-child');
        var $unfeaturedHeaderFive = $('.product-unfeatured-5 .pro-card-headers').children('h4:first-child');
        var $unfeaturedHeaderSix= $('.product-unfeatured-6 .pro-card-headers').children('h4:first-child');
        //var $nearestHeader = $('.pro-card-clip').closest('.pro-card-headers').find('h4:first-child');
        $('.product-featured .promo-product-cards .pro-card-wrapper .pro-card:first-child .pro-card-clip').next('h4').detach().insertAfter($featuredHeader).css({
          'margin-top': '0',
          'text-align': 'center'
        });

        $('.product-unfeatured-2 .pro-card-wrapper .pro-card:first-child .pro-card-clip').next('h4').detach().insertAfter($unfeaturedHeaderTwo).css({
          'margin-top': '0',
          'text-align': 'center'
        });

        $('.product-unfeatured-3 .pro-card-wrapper .pro-card:nth-child(2) .pro-card-clip').next('h4').detach().insertAfter($unfeaturedHeaderThree).css({
          'margin-top': '0',
          'text-align': 'center'
        });

        $('.product-unfeatured-4 .pro-card-wrapper .pro-card:nth-child(2) .pro-card-clip').next('h4').detach().insertAfter($unfeaturedHeaderFour).css({
          'margin-top': '0',
          'text-align': 'center'
        });

        $('.product-unfeatured-5 .pro-card-wrapper .pro-card:nth-child(3) .pro-card-clip').next('h4').detach().insertAfter($unfeaturedHeaderFive).css({
          'margin-top': '0',
          'text-align': 'center'
        });

        $('.product-unfeatured-6 .pro-card-wrapper .pro-card:nth-child(3) .pro-card-clip').next('h4').detach().insertAfter($unfeaturedHeaderSix).css({
          'margin-top': '0',
          'text-align': 'center'
        });


        $('.primary-two-up').each(function () {
          promoHeight = $(this).find('.pro-card-wrapper').outerHeight();
          $(this).find('.pro-card-wrapper').find('.pro-card-img').css('height', promoHeight * .55)
        });
        $('.primary-three-up').each(function () {
          promoHeight = $(this).find('.pro-card-wrapper').find('.pro-card').find('.pro-card-content').outerHeight();
          $(this).find('.pro-card-wrapper').find('.pro-card-img').css('height', promoHeight)
        });
      }
    }
  });


})
